export const APP_LOCALE_ID:string = "de-DE";